@if (activeUserStore.user$()) {
	<div
		class="user-profile"
		(click)="userProfilePanel.toggle($event)"
	>
		<div class="avatar-container">
			@let portraitImage = activeUserStore.portraitStoredFile$()?.webEncode;
			@if (portraitImage) {
				<img
					[src]="portraitImage"
					[alt]="activeUserStore.user$().displayName"
					class="avatar-img"
				/>
			} @else {
				<icon icon="fa-regular fa-user w-full h-full p-3" />
			}
		</div>

		@if (!sidenavService.collapsed()) {
			<div class="user-info">
				<div class="user-name">{{ activeUserStore.user$().displayName }}</div>
				<div class="user-title">{{ activeUserStore.user$().title }}</div>
			</div>
		}
	</div>

	<p-overlayPanel
		#userProfilePanel
		styleClass="mb-4 p-0"
	>
		@defer (when activeUserStore.user$()) {
			<div class="user-profile-card">
				<!-- Header section with gradient background and user info -->
				<div class="profile-header">
					<div class="avatar-large">
						@if (portraitImage) {
							<img
								[src]="portraitImage"
								[alt]="activeUserStore.user$().displayName"
								class="avatar-img"
							/>
						} @else {
							<icon
								class="w-full h-full text-primary-500"
								icon="fad fa-user fa-2x"
							/>
						}
					</div>
					<div class="user-basic-info">
						<h3 class="user-name">{{ activeUserStore.user$().displayName }}</h3>
						<p class="user-title">{{ activeUserStore.user$().title }}</p>
					</div>
				</div>

				<!-- User contact details section -->
				<div class="contact-details">
					<div
						class="contact-item"
						[cdkCopyToClipboard]="activeUserStore.user$().email"
						(cdkCopyToClipboardCopied)="
							toastService.open({
								message: 'dccomp.userProfile.emailCopied',
								type: 'success',
								life: 2500,
							})
						"
					>
						<dc-icon
							name="envelope"
							type="regular"
							size="sm"
						/>
						<span class="contact-text">{{ activeUserStore.user$().email }}</span>
					</div>
					@if (activeUserStore.user$().phonenumber) {
						<div
							class="contact-item"
							[cdkCopyToClipboard]="activeUserStore.user$().phonenumber"
							(cdkCopyToClipboardCopied)="
								toastService.open({
									message: 'dccomp.userProfile.phoneCopied',
									type: 'success',
									life: 2500,
								})
							"
						>
							<dc-icon
								name="phone"
								type="regular"
								size="sm"
							/>
							<span class="contact-text">{{ activeUserStore.user$().phonenumber }}</span>
						</div>
					}
					<div
						class="contact-item"
						[cdkCopyToClipboard]="authStore.companyName()"
						(cdkCopyToClipboardCopied)="
							toastService.open({
								message: 'dccomp.userProfile.companyCopied',
								type: 'success',
								life: 2500,
							})
						"
					>
						<dc-icon
							name="building"
							type="regular"
							size="sm"
						/>
						<span class="contact-text">{{ authStore.companyName() }}</span>
					</div>
					@if (activeUserStore.user$().department) {
						<div
							class="contact-item"
							[cdkCopyToClipboard]="activeUserStore.user$().department"
							(cdkCopyToClipboardCopied)="
								toastService.open({
									message: 'dccomp.userProfile.departmentCopied',
									type: 'success',
									life: 2500,
								})
							"
						>
							<dc-icon
								name="users"
								type="solid"
								size="sm"
							/>
							<span class="contact-text">{{ activeUserStore.user$().department }}</span>
						</div>
					}
				</div>

				<!-- Language selection section -->
				<div class="language-selector">
					<h4 class="section-title">{{ 'dccomp.userProfile.selectLanguage' | translate }}</h4>
					<div class="language-options">
						<button
							class="language-option"
							[class.active]="languageService.currentLang$() === 'he'"
							(click)="changeLanguage('he', userProfilePanel)"
						>
							<span class="lang-label">{{ 'app-layout.sidenav.user-profile.language.hebrew' | translate }}</span>
						</button>
						<button
							class="language-option"
							[class.active]="languageService.currentLang$() === 'en'"
							(click)="changeLanguage('en', userProfilePanel)"
						>
							<span class="lang-label">{{ 'app-layout.sidenav.user-profile.language.english' | translate }}</span>
						</button>
						<button
							class="language-option"
							[class.active]="languageService.currentLang$() === 'es'"
							(click)="changeLanguage('es', userProfilePanel)"
						>
							<span class="lang-label">{{ 'app-layout.sidenav.user-profile.language.spanish' | translate }}</span>
						</button>
					</div>
				</div>

				<!-- Action buttons section -->
				<div class="action-buttons">
					<button
						class="profile-btn edit-profile"
						(click)="editProfile(activeUserEditProfileDialog); userProfilePanel.toggle($event)"
					>
						<dc-icon
							name="user-pen"
							type="regular"
							size="sm"
						/>
						<span>{{ 'dccomp.userProfile.editProfile' | translate }}</span>
					</button>

					<button
						class="profile-btn logout"
						(click)="logout()"
					>
						<dc-icon
							name="arrow-right-from-bracket"
							type="regular"
							size="sm"
						/>
						<span>{{ 'dccomp.userProfile.logout' | translate }}</span>
					</button>
				</div>
			</div>
		} @placeholder {
			<div>
				<icon
					class="w-full h-full text-primary-500"
					icon="fad fa-user fa-2x"
				/>
			</div>
		}
	</p-overlayPanel>

	<ng-template
		#activeUserEditProfileDialog="DcDialog"
		DcDialog="active-user-edit-profile"
		width="40%"
		height="80%"
		[mobileDialogDims]="['100%', '100%', '98vw', '78vh']"
	>
		<dc-active-user-edit-profile
			(submitUser)="onProfileUpdated(activeUserEditProfileDialog)"
			(cancelForm)="activeUserEditProfileDialog.close()"
		/>
	</ng-template>
}
